import ContentForm from './component';

export default ContentForm;
